module.exports = __webpack_public_path__ + "img/Credencial-D.f0930903.svg";